var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('h3',{staticClass:"chart-label m-4"},[_vm._v(_vm._s(this.title))]),_c('div',{staticClass:"p-3",attrs:{"id":"marks-histogram"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }